<div class="status-header">
  <h2>Taksten er klar</h2>
  <mat-icon [svgIcon]="IconNames.ice_checkmark_circle_outline" />
</div>

<div class="calculation-container">
  <div class="attention-card-success calculation-header">
    <span>Estimert pant</span>
    <span class="calculation-price">{{ totalPrice() | priceFormat: PriceType.OneTime }}</span>
  </div>
  <div class="calculation-addends">
    <div class="addend">
      <span class="addend-title">Din pant</span>
      <span class="calculation-price">
        {{ estimatedPrice() | priceFormat: PriceType.OneTime }}
      </span>
      <p>{{ deviceDisplayName() }}</p>
      <p>IMEI: {{ imei() }}</p>
    </div>
    @if (isCalculatingVendorSubsidy()) {
      <app-spinner />
    } @else {
      @if (vendorSubsidy(); as vendorSubsidy) {
        <div class="addend">
          <span class="addend-title">{{ vendorSubsidy.displayInfo?.title || 'Kampanje!' }}</span>
          <span class="calculation-price">
            {{ vendorSubsidy.voucherAmount?.amountIncludingVAT | priceFormat: PriceType.OneTime }}
          </span>
          @if (vendorSubsidy.displayInfo?.description; as description) {
            <p>{{ description }}</p>
          }
        </div>
      }
    }
    @if (iceSubsidyForZeroPrice(); as amount) {
      <div class="addend">
        <span class="addend-title">ice miljøbonus</span>
        <span class="calculation-price">
          {{ amount | priceFormat: PriceType.OneTime }}
        </span>
      </div>
    }
  </div>
</div>

@if (iceSubsidyForZeroPrice(); as amount) {
  <div class="additional-ice-voucher">
    <mat-icon [svgIcon]="IconNames.ice_recycle" />
    <span>
      <p class="additional-ice-voucher-title">{{ amount | priceFormat: PriceType.OneTime }} i miljøbonus</p>
      <p>ice ønsker å tilby kunden en liten bonus for å sende mobilen inn til gjenvinning.</p>
    </span>
  </div>
}

<div class="confirmation-terms">
  <p>Vilkår</p>
  <ul>
    <li>Kunden må eie telefonen de ønsker å pantsette, og telefonen må være fri for heftelser</li>
    <li>Ved å akseptere den angitte verdien eller rabattkupongen, overfører kunden eierskapet til telefonen</li>
    <li>Kunden må sende inn den gamle telefonen innen 14 dager, hvis ikke kan de bli fakturert den gitte rabatten</li>
    <li>
      Ice kan fakturere kunden hvis tilstanden vurderes betydelig forskjellig fra det kunden har oppgitt. Kunden kan velge å
      få tilbake telefonen eller betale differansen i verdi
    </li>
  </ul>
</div>

<mat-checkbox disableRipple id="trade-in-confirmation-terms-checkbox" [formControl]="confirmationTerms">
  <span class="confirmation-terms-checkbox-text">Kunden er informert om disse vilkårene</span>
</mat-checkbox>

<div class="action-buttons">
  <app-ice-button color="outlined" testId="trade-in-back-button" (click)="backClicked.emit()">Tilbake</app-ice-button>
  <app-ice-button
    color="primary"
    testId="add-trade-in-to-cart-button"
    [disabled]="!confirmationTerms.value"
    (click)="addToCartClicked()"
  >
    Legg til handlekurv
  </app-ice-button>
</div>
